import { Icon } from '@sunwebgroup/uds-ui/icon'
import cn from 'classnames'
import * as React from 'react'
import styles from './BaseInput.module.css'

interface RootProps extends React.HTMLAttributes<HTMLDivElement> {
  disabled?: boolean
}

export function Root({ className, disabled, ...rest }: RootProps) {
  return <div className={cn(styles.root, disabled && styles.rootDisabled, className)} {...rest} />
}

interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  hasValue?: boolean
}

export function Box({ className, hasValue, ...rest }: BoxProps) {
  return <div className={cn(styles.box, hasValue && styles.boxHasValue, className)} {...rest} />
}

export function Content({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn(styles.content, className)} {...rest} />
}

export function ChevronDown() {
  return (
    <div className={styles.chevronDownWrapper}>
      <Icon glyph="ChevronDown" size={20} />
    </div>
  )
}
